import React from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

const HowItWork = React.forwardRef((props, ref) => {

    useEffect(()=>{
        AOS.init({duration:2000})
    });

    return (
        <>
            <div className="HowItWork my-5" ref={ref}>
                <Container >
                    <div className="howWorkContent" data-aos="fade-up">

                        <Stack direction='vertical' gap={2}>
                            <h1 className='text-center mb-0 fontWeight-800' style={{
                                color:'#0F75D6'
                            }}>How it Works</h1>
                            <h5>As Smooth As Butter </h5>
                        </Stack>
                        <Row>
                            <Col md={3}>
                                <Stack direction='vertical' gap={2} className="workContent">
                                    <h6 className='stepwise'>Step-1 </h6>
                                    <img src="/fexperience/assets/icon/01-work.png" className='img-fluid WorkIcon' alt="" />
                                    <h5> Submit CAD/3D files </h5>
                                </Stack>
                            </Col>
                            <Col md={3}>
                                <Stack direction='vertical' gap={2} className="workContent">
                                    <h6 className='stepwise'>Step-2</h6>
                                    <img src="/fexperience/assets/icon/02-work.png" className='img-fluid WorkIcon' alt="" />
                                    <h5> Activation & setup </h5>
                                </Stack>
                            </Col>
                            <Col md={3}>
                                <Stack direction='vertical' gap={2} className="workContent">
                                    <h6 className='stepwise'>Step-3</h6>
                                    <img src="/fexperience/assets/icon/03-work.png" className='img-fluid WorkIcon' alt="" />
                                    <h5> Review and refine </h5>
                                </Stack>
                            </Col>
                            <Col md={3}>
                                <Stack direction='vertical' gap={2} className="workContent">
                                    <h6 className='stepwise'>Step-4</h6>
                                    <img src="/fexperience/assets/icon/04-work.png" className='img-fluid WorkIcon' alt="" />
                                    <h5>Go live &  monitor progress</h5>
                                </Stack>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    )
});

export default HowItWork
